import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    LinearProgress
} from '@mui/material';
import { useGlobalStores } from '../../../../hooks/use_global_stores';
import "../../../../utils/number_extensions";
import { IBudgetProgress } from '../../../../config/budget';

interface IBudgetsProgressProps {
    budgets: IBudgetProgress[];
}


const calculate = (item: IBudgetProgress): number => {
    let progress = item.amount_used * 100 / item.amount;
    if (progress > 100) {
        progress = 100;
    }

    return progress;
};

const getColor = (item: IBudgetProgress): "primary" | "warning" | "error" => {
    let progress = item.amount_used * 100 / item.amount;
    if (progress > 100) {
        return 'error';
    } else if (progress > 75) {
        return 'warning';
    }
    return 'primary';
};

export const BudgetsProgress = ({budgets}: IBudgetsProgressProps) => {
    const { currencyStore } = useGlobalStores();

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Budgets
                </Typography>

                {!budgets.length ? (
                    <Typography variant="h6" color="text.secondary" align="center">
                        No budgets available
                    </Typography>
                ) : (
                    budgets.map((item, idx) => (
                        <Box key={idx} sx={{ marginBottom: 2 }}>
                            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <Typography variant="button" sx={{fontWeight: 400}}>{item.name}</Typography>
                                <Typography variant="button" sx={{fontWeight: 400, fontSize: 12}}>
                                    <strong>{item.amount_used.toCurrency(currencyStore.currentCurrency, {})}</strong>
                                    {" / "}
                                    {item.amount.toCurrency(currencyStore.currentCurrency, {})}
                                </Typography>
                            </Box>
    
                            <LinearProgress
                                variant="determinate"
                                value={calculate(item)}
                                sx={{ height: 12, borderRadius: 2 }}
                                color={getColor(item)}
                            />
                        </Box>
                    ))
                )}
            </CardContent>
        </Card>
    );
}
